<template>
  <div>
    <v-dialog
      v-model="dialogDeposit"
      persistent
      max-width="600"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <v-card class="pb-10">
        <!-- Title Dialog -->
        <v-card-title>
          <h3 class="title mb-0">{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()"> <v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />

        <!-- FORM PARA INFORMAR O VALOR -->
        <v-scale-transition hide-on-leave>
          <template v-if="step == 1">
            <v-form lazy-validation>
              <v-card-text class="px-6 mx-auto mt-4" style="max-width: 400px">
                <div class="mb-2">
                  <v-text-field
                    v-model="valueDeposit"
                    type="number"
                    placeholder="00,00"
                    label="Informe o valor"
                    prefix="R$"
                    :hide-details="!disableDepositButton"
                    outlined
                    class="grey--text"
                    clearable
                    tabindex="2"
                    autofocus
                    :rules="[minDepositRule]"
                  ></v-text-field>
                  <div
                    class="d-flex justify-space-between mt-3"
                    v-if="
                      hasFirstDeposit &&
                        valueDeposit != '' &&
                        !disableDepositButton
                    "
                  >
                    <strong>
                      BÔNUS NO PRIMEIRO DEPÓSITO DE
                      <span style="color:LimeGreen"> R$ {{ bonusValue }}</span>
                    </strong>
                  </div>
                </div>
                <span>
                  Os depósitos são realizados via Pix. <br />
                  É obrigatório ter seu <strong>CPF</strong> cadastrado.</span
                >
              </v-card-text>
              <v-card-actions
                class="pa-6 pt-0 mx-auto"
                style="max-width: 400px"
              >
                <!-- <v-divider class="mr-2"></v-divider> -->
                <v-btn
                  :loading="loading"
                  tabindex="8"
                  block
                  type="submit"
                  class="primary darken-1"
                  @click.prevent="submmitDepoist"
                  :disabled="disableDepositButton || loading"
                  >Gerar Pix</v-btn
                >
              </v-card-actions>
            </v-form>
          </template>
        </v-scale-transition>
        <v-scale-transition hide-on-leave>
          <template v-if="step == 2">
            <!-- <v-card-title class="mb-0 pb-0">
                <div>
                  <h3 class="headline mb-0">Pagamento</h3>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title> -->
            <v-card-text
              class="px-6 mx-auto mt-4 mb-6"
              style="max-width: 400px"
            >
              <div class="mt-3">
                <p class="white--text body-1">
                  Para realizar o pagamento via pix faça a leitura do Qr Code no
                  aplicativo do seu banco ou clique no botão para copiar o
                  código.
                </p>
                <div class="my-4 white--text body-1">
                  Valor do depósito: R$ {{ feedbackDeposit }}
                </div>
              </div>
              <v-btn block @click="$copy(code)" color="primary" class="mb-4">
                <v-icon small left>mdi-content-copy</v-icon>código Pix
                Copia/Cola</v-btn
              >
              <div class="d-flex subtitle-1 justify-start align-center">
                <v-divider class="mr-4"></v-divider>
                <div>OU</div>
                <v-divider class="ml-4"></v-divider>
              </div>
              <div class="mx-auto mt-2" style="width: 250px; height: 250px">
                <v-img
                  :src="Qrcode"
                  max-height="200px"
                  max-width="200px"
                  class="mx-auto"
                ></v-img>
                <v-btn
                  @click="balanceOnline"
                  block
                  class="mt-6"
                  color="green"
                  :disabled="disabledBtnPag"
                  >Confirmar pagamento</v-btn
                >
              </div>
            </v-card-text>
          </template>
        </v-scale-transition>
        <v-scale-transition hide-on-leave>
          <template v-if="step == 3">
            <v-card-text class="px-6 mx-auto mt-10" style="max-width: 600px">
              <div class="text-center pa-10">
                <v-icon color="green" class="mb-6" size="80"
                  >mdi-checkbox-marked-circle-outline</v-icon
                >
                <div class="title white--text">Depósito PIX confirmado.</div>
                <div class="subtitle-1">
                  Obrigado! Agora você pode aproveitar o melhor do
                  entretenimento esportivo. Faça suas apostas e boa Sorte!
                </div>
                <v-btn
                  @click="(step = 1), (title = 'Depósito PIX')"
                  class="my-4"
                  color="green"
                  >Novo depósito</v-btn
                >
              </div>
            </v-card-text>
          </template>
        </v-scale-transition>
      </v-card>
    </v-dialog>
    <!-- Snackbar error -->
    <v-snackbar v-model="snackbar" color="warning">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { validate } from "@/util/form-validate";
export default {
  name: "Dialog-Deposit",
  data: () => ({
    // Deposit
    hasFirstDeposit: false,
    percentualBonus: 0,
    maxBonus: 0,
    valueDeposit: "",
    rules: {
      required: validate.required,
    },
    loading: false,
    respose: "",
    Qrcode: "",
    step: 1,
    title: "Depósito PIX",
    disabledBtnPag: false,
    snackbar: false,
    text: "",
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: ",00",
      precision: 2,
      masked: false,
    },
  }),
  computed: {
    dialogDeposit() {
      return this.$store.state.dialogDeposit;
    },
    bonusValue() {
      const earnBonus = this.valueDeposit * this.percentualBonus;

      if (earnBonus > this.maxBonus) {
        return this.maxBonus;
      }

      return earnBonus.toFixed(2);
    },
    minDepositRule() {
      const minDeposit = parseFloat(this.$store.state.operators.deposit_min);

      if (minDeposit <= parseFloat(this.valueDeposit)) {
        return true;
      }

      return `O valor minímo para depósito é de R$ ${minDeposit.toFixed(2)}.`;
    },
    disableDepositButton() {
      const minDeposit = parseFloat(this.$store.state.operators.deposit_min);

      if (minDeposit <= parseFloat(this.valueDeposit)) {
        return false;
      }

      return true;
    },
  },
  mounted() {
    // this.$store.commit("dialogDeposit", false);
    // Valores Padrão
    this.title = "Depósito PIX";
    this.step = 1;
    this.code = "";
    this.Qrcode = "";
    document.removeEventListener("visibilitychange", this.listener, false);
    this.valueDeposit = this.$store.state.operators.deposit_min;

    this.$nextTick(() => {
      if (this.dialogDeposit) {
        this.checkUserHasFirstDeposit();
      }
    });
  },
  watch: {
    dialogDeposit(val) {
      if (val) {
        this.checkUserHasFirstDeposit();
      }
      if (!val) {
        this.hasFirstDeposit = false;
      }
    },
  },
  methods: {
    // Close Dialog
    closeDialog() {
      this.$store.commit("dialogDeposit", false);
      this.code = "";
      this.Qrcode = "";
      this.step = 1;
      this.title = "Depósito PIX";
      this.balanceOnline();
      // this.valueDeposit = "";
      this.valueDeposit = this.$store.state.operators.deposit_min;

      // Remove Listener
      document.removeEventListener("visibilitychange", this.listener, false);
    },

    // Recuperando PIX COPIA/COLA E QRCODE;
    async submmitDepoist() {
      this.loading = true;
      const body = {
        value: Number(this.valueDeposit).toFixed(2),
        is_deposit_bonus: this.hasFirstDeposit ? "1" : "0",
      };
      this.$axios
        .post("/player/online/bank/depositOnline", this.$formdata(body))
        .then((resp) => {
          this.Qrcode = resp.data.link_billet;
          this.code = resp.data.code;
          this.feedbackDeposit = body.value;
          this.step = 2;
          this.title = "Pagamento";
        })
        .then(() => {
          // Ouvindo o pagamento
          this.listenerDeposit();
          // Register Event generate_pix Analytics;
          this.$gtag.generate_pix(body.value, this.hasFirstDeposit);
        })
        .then(() => {
          this.valueDeposit = "";
        })
        .catch((err) => {
          if (err.response.status === 403) {
            this.closeDialog();
            this.$router.push({ name: "Perfil" });
          }
          // console.log(err.response.data.messages.error);
          this.snackbar = true;
          this.text = err.response.data.messages.error;
          this.color = "orange";
          // this.$get.playerBalance();
        })
        .finally(() => (this.loading = false));
    },

    // Descobrindo se é o primeiro Deposito do User
    checkUserHasFirstDeposit() {
      this.loading = true;
      this.$axios
        .get("/player/bonus/user/hasFirstDeposit")
        .then((resp) => {
          // console.log(resp.data);
          this.hasFirstDeposit = !resp.data.dados;
          if (this.hasFirstDeposit) {
            this.percentualBonus = resp.data.percentual_bonus;
            this.maxBonus = resp.data.valor_max_bonus;
          }
        })
        .catch((err) => {
          this.text = err.response.data.messages.error;
          this.color = "alert";
        })
        .finally(() => (this.loading = false));
    },

    // Refresh Saldo após Deposito
    // Refresh Cash
    balanceOnline() {
      (this.disabledBtnPag = true),
        this.$axios
          .get("/player/online/bank/balanceOnline")
          .then((resp) => {
            const cash = Number(this.$store.state.cash);
            const cashResp = Number(resp.data.dados.balance);

            if (cashResp > cash) {
              this.step = 3;
              this.title = "Obrigado!";
              this.$gtag.consolidated_pix(
                this.feedbackDeposit,
                this.hasFirstDeposit
              );
              document.removeEventListener(
                "visibilitychange",
                this.listener,
                false
              );
            }

            // Update Saldo;
            this.$store.commit("setCash", resp.data.dados.balance);
            this.$store.commit("setBonus", {
              value: resp.data.dados.balance_bonus,
              status: resp.data.dados.balance_bonus_status,
            });
          })
          .catch((err) => {
            console.log(err.response);
          })
          .finally(() => (this.disabledBtnPag = false));
    },

    // Observando Pagamento
    listenerDeposit() {
      document.addEventListener("visibilitychange", this.listener, false);
    },
    listener() {
      this.balanceOnline();
    },
  },
};
</script>
